import { render, staticRenderFns } from "./b.vue?vue&type=template&id=3bef8128&scoped=true&"
import script from "./b.vue?vue&type=script&lang=js&"
export * from "./b.vue?vue&type=script&lang=js&"
import style0 from "./b.vue?vue&type=style&index=0&id=3bef8128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef8128",
  null
  
)

export default component.exports